module.exports = __webpack_public_path__ + "img/icon_excel.d67d3550.svg";